import React from 'react';
import '../styles/WhyMoveToCloud.css';

// Image imports
import agilityIcon from '../../../../assets/solutions/cloudadoption/agility.png';
import costIcon from '../../../../assets/solutions/cloudadoption/cost.png';
import securityIcon from '../../../../assets/solutions/cloudadoption/enhanced.png';
import continuityIcon from '../../../../assets/solutions/cloudadoption/business.png';
import innovationIcon from '../../../../assets/solutions/cloudadoption/innovation.png';

const WhyMoveToCloud = () => {
  const reasons = [
    {
      title: "Agility & Scalability",
      description: "Instantly scale resources to match your business’s growth and changing demands.",
      image: agilityIcon
    },
    {
      title: "Cost Savings",
      description: "Shift from capital expenses to pay-as-you-go models, reducing overall IT costs.",
      image: costIcon
    },
    {
      title: "Innovation",
      description: "Accelerate your time-to-market and empower your teams with the latest technologies.",
      image: innovationIcon
    },
    {
      title: "Enhanced Security",
      description: "Benefit from advanced security features and compliance frameworks.",
      image: securityIcon
    },
    {
      title: "Business Continuity",
      description: "Rely on high availability and disaster recovery for your critical systems.",
      image: continuityIcon
    },
    
  ];

  return (
    <div className="why-cloud-container">
      <h2 className="why-cloud-title">Why Move to the Cloud?</h2>
      <div className="why-cloud-grid">
        {reasons.map((reason, index) => (
          <div key={index} className="why-cloud-card">
            <img src={reason.image} alt={reason.title} className="why-cloud-icon" />
            <h3 className="why-cloud-heading">{reason.title}</h3>
            <p className="why-cloud-description">{reason.description}</p>
          </div>
        )
        )}
      </div>
    </div>
  );
};

export default WhyMoveToCloud;
